var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-circle status",class:("status-" + _vm.color)}),_vm._v(" "+_vm._s(_vm.description)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }